"use strict";
import {http} from '../../core';
const RequestService = http.create();
import Config from "../../app.config";
const BASE_API = Config.BASE_API;
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {
    // 事件列表
    getList:function (params) {
        return RequestService.get("event/list",params);
    },
    //新增时获取事件模板
    getEventTemplateList(params){
        return RequestService.get('case/template/list',params)
    },
    //选择模板后请求模板详情
    getEventTemplate(params){
        return RequestService.get('case/template/describe',{id:params})
    },
    // 新增事件
    addEvent:function (params) {
        return RequestService.post('event/add',params);
    },
    // 修改事件
    updateEvent:function (params) {
        return RequestService.post('event/update',params);
    },
    // 事件详情
    detail:function (params) {
        return RequestService.get("event/detail",params);
    },
    // 事件删除
    deteleEvent:function (params) {
        return RequestService.post("event/delete",params);
    },
    // 事件操作
    handle:function (params) {
        return RequestService.post("event/handle",params);
    },
    // 更新SLA
    updateSla:function (params) {
        return RequestService.post("event/updateSla",params);
    },
    // 根据关键字获取知识列表
    getKnowledgeList:function (params) {
        return RequestService.get("knowledge/query",params);
        // return Promise.resolve([
        //     { id:1 ,}
        // ])
    },
    // 繁忙度统计---组繁忙度
    busynessGroup:function (departmentId) {
        return RequestService.get("organization/group/busyness",{ departmentId:departmentId })
    },
    // 繁忙度统计---人员繁忙度
    busynessUser:function (userId) {
        return RequestbaseURL.get("itsm/v2/organization/user/busyness",{ internalUserid:userId })
    },







}
